'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('../util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Components
 */

/**
 * @component
 *
 * `Label` is a simple component that displays a label.
 *
 * @example
 * return <Label htmlFor='something'>Label for thing</Label>
 */

var Label = function (_React$Component) {
    (0, _inherits3.default)(Label, _React$Component);

    function Label() {
        (0, _classCallCheck3.default)(this, Label);
        return (0, _possibleConstructorReturn3.default)(this, (Label.__proto__ || (0, _getPrototypeOf2.default)(Label)).apply(this, arguments));
    }

    (0, _createClass3.default)(Label, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                htmlFor = _props.htmlFor,
                labelProps = _props.labelProps,
                modifier = _props.modifier,
                peer = _props.peer,
                spruceName = _props.spruceName,
                style = _props.style;


            return _react2.default.createElement('label', (0, _extends3.default)({}, labelProps, {
                htmlFor: htmlFor,
                className: (0, _SpruceClassName2.default)({ name: spruceName, modifier: modifier, className: className, peer: peer }),
                children: children,
                style: style
            }));
        }
    }]);
    return Label;
}(_react2.default.Component);

Label.defaultProps = {
    className: '',
    labelProps: {},
    modifier: '',
    peer: '',
    spruceName: 'Label',
    style: {}
};
exports.default = Label;


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/component/Label.js
// module id = 152
// module chunks = 35783957827783 114276838955818 162898551421021